import ActionButton from 'components/ActionButton';
import AddComparableItemModal from 'components/AddComparableItemModal';
import Currency from 'components/Currency/Currency';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import ViewComparableItemModal from 'components/ViewComparableItemModal';
import { tableStyles } from 'css/tableStyles';
import React, { useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { removeComparableItem } from 'services';
import { DATE_FORMATS, USER_ROLES, formatDate, isUserAuthorized, showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const ComparableItems = props => {
  const [detailsModalOpen, setDetailsModalOpen] = useState<boolean>(false);
  const [itemToView, setItemToView] = useState<Record<string, any>>({});
  const {
    itemId,
    comparableItems,
    addModalOpen,
    toggleAddModal,
    refetchComparableItems,
    userRoles,
  } = props;
  const isUserAuthorizedToEdit = isUserAuthorized(userRoles, [USER_ROLES.PACKER, USER_ROLES.SUPERVISOR, USER_ROLES.MANAGER, USER_ROLES.ADMIN]);

  const deleteComparableItem = async (id: string) => {
    try {
      await removeComparableItem(itemId, id);
      await refetchComparableItems();
      showSuccess('Comparable Item removed successfully.');
    } catch (e) {
      showError(e);
    } finally {
    }
  };
  
  const columns = useMemo(() => [
    {
      name: 'ItemID',
      selector: 'id',
      sortable: false,
    },
    {
      name: 'Source',
      selector: 'source',
      sortable: false,
    },
    {
      name: 'Date',
      selector: 'date',
      sortable: false,
      format: row => typeof row.date === 'string' ? row.date : formatDate(row.date, DATE_FORMATS.YYYY_MM_DD),
    },
    {
      name: 'Unit',
      selector: 'unit',
      sortable: false,
      width: '100px',
    },
    {
      name: 'Price',
      selector: 'price',
      sortable: false,
      // eslint-disable-next-line react/display-name
      format: row => <Currency amount={parseFloat(row.price?.toFixed(2))} default={'-'} />,
    },
    {
      name: 'Action',
      selector: '',
      sortable: true,
      omit: !isUserAuthorizedToEdit,
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className={'ml-3'}>
          <DeleteActionForTable
            onClick={() => deleteComparableItem(row.id)}
          />
        </div>
      ),
    },
  ], []);
  
  const onRowClick = (row: Record<string, any>) => {
    setItemToView(row);
    setDetailsModalOpen(true);
  };
  
  return (
    <>
      {addModalOpen && (
        <AddComparableItemModal
          itemId={itemId}
          onSuccess={refetchComparableItems}
          toggleModal={toggleAddModal}
        />
      )}
      {detailsModalOpen && (
        <ViewComparableItemModal
          itemDetails={itemToView}
          toggleModal={() => setDetailsModalOpen(!detailsModalOpen)}
        />
      )}
      <div className={styles['related-items-container']}>
        <div className={styles['section-header']}>
          <div className={styles['section-heading']}>Comparable Items</div>
          {isUserAuthorizedToEdit && <ActionButton
            active={true}
            isLoading={false}
            onClick={toggleAddModal}
            text={<>Comparable Item <span className={'ml-3'}>+</span></>}
          />}
        </div>
        <DataTable
          columns={columns}
          noHeader={true}
          data={comparableItems}
          highlightOnHover={true}
          customStyles={tableStyles}
          pagination={false}
          onRowClicked={onRowClick}
        />
      </div>
    </>
  );
};

export default ComparableItems;